import { StatusBanner, Flex } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import type { ConnectorProps } from "../../connector-button";
import { Connector as ConnectorButton } from "../../connector-button";
import type { ConnectorWithModal } from "../../connector-content/interface";
import { ButtonWrapper } from "../platform-connection-list.styles";
import { PlatformDetails } from "../platform-details";
import { PlatformImage } from "../platform-image";

export interface BaseConnectionPanelProps {
  name: string;
  domain?: string;
  connectorType: string;
  reconnectionData?: ConnectorWithModal | ConnectorProps;
  children?: React.ReactNode;
}

export const BaseConnectionPanel = ({
  name,
  domain,
  connectorType,
  reconnectionData,
  children,
}: BaseConnectionPanelProps) => {
  const intl = useIntl();

  //TODO: Change this to just be the panel contents, not the whole panel!!!
  return (
    <Flex direction="column" gap="6" padding={["6", "0", "0"]}>
      <Flex align="center" wrap="nowrap">
        <PlatformImage connectorType={connectorType} />
        <PlatformDetails name={name} domain={domain} />
      </Flex>
      {reconnectionData && (
        <>
          <StatusBanner
            variant="critical"
            title={intl.formatMessage(
              {
                id: "shared-ui: connection lost alert",
                defaultMessage: "We’ve lost connection to this {accountType} account",
              },
              { accountType: connectorType }
            )}
            subheading={intl.formatMessage({
              id: "shared-ui: please reconnect platform",
              defaultMessage: "Please reconnect the account",
            })}
          />
          <ButtonWrapper>
            <ConnectorButton {...reconnectionData} mode="Button" />
          </ButtonWrapper>
        </>
      )}
      {children}
    </Flex>
  );
};
